import { useContext, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export default function LoginPage() {
  const { loginWithGoogle, error } = useContext(AuthContext);
  const navigate = useNavigate();
  const [localError, setLocalError] = useState(null);

  const handleSuccess = async (credentialResponse) => {
    const res = await loginWithGoogle(credentialResponse);
    if (res && res.success) {
      // after login, navigate to /app which will route to onboarding/dashboard based on server status
      navigate("/app", { replace: true });
    } else {
      setLocalError("Login failed");
    }
  };

  return (
    <div>
      <h2 className="mb-4">
        <i className="bi bi-box-arrow-in-right me-2 text-primary"></i>
        Login
      </h2>
      <GoogleLogin onSuccess={handleSuccess} onError={() => setLocalError("Google Login failed")} />
      {(localError || error) && (
        <div className="alert alert-danger d-flex align-items-center mt-3" role="alert">
          <i className="bi bi-exclamation-circle-fill text-danger"></i>
          <span className="ms-2">{localError || error}</span>
        </div>
      )}
    </div>
  );
}
